import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import Icon from "../../icon/icon.component"
import StatBox from "../../listing/statbox.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    protectedClassName: string
    accountFeatureKey: string
    className: string
    type: "button" | "submit" | "reset"
    children: JSX.Element
    showLock: boolean
    premium: boolean
    message: string
    label: string
    colorStyle: string
    boxType: string
    count: number
    isDashboard: boolean
    isEditable: boolean
    amount: number
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent) => void
    intl: Intl
}

const DivStatBoxWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true

    const lockedItem = <span key={"tooltip-container"} data-tip data-for={"divLock"}>
        <div key={"div-wrapper"} className={props.protectedClassName} onClick={(e) => {
            handleClick(e, props, setDisplayModal)
        }}>
            <ReactTooltip place={"bottom"} className="divLock" id={"divLock"} type="warning" effect="solid" multiline={true}>
                {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
            </ReactTooltip>
            <StatBox
                label={props.label}
                colorStyle={props.colorStyle}
                boxType={"open"}
                count={props.count}
                className={props.className}
                isDashboard={props.isDashboard}
                isEditable={props.isEditable}
                amount={props.amount}
            >
                {props.children} {showLock && <Icon value="lock" className="lock" />}
            </StatBox>
        </div>
    </span>

    const item = <div key={"div-wrapper"} className={props.className} onClick={e => {
        props.onClick(e)
    }}>
        <StatBox
            label={props.label}
            colorStyle={props.colorStyle}
            boxType={"open"}
            count={props.count}
            className={props.className}
            isDashboard={props.isDashboard}
            isEditable={props.isEditable}
            amount={props.amount}
        >
            {props.children}
        </StatBox>
    </div>

    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () { return }}
            onClickProtected={props.onClickProtected || function () { return }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () { return }}
        >

        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(DivStatBoxWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/divStatBoxWrapper.component.tsx